export default {
  methods: {
    getModuleURL(abbr) {
      switch (abbr.toLowerCase()) {
        case "ap":
          return "/app/analyse-complete-acteurs";
        case "ar":
          return "/app/analyse-risques";
        case "mp":
          return "/app/matrice-priorisation";
        case "mr":
          return "/app/modele-resultats";

        default:
          return "/not/found";
      }
    },

    async doLogout() {
      if (
        (await this.$swal.fire({
          title: "Voulez vous vraiment vous deconnecter",
          showDenyButton: true,
          denyButtonText: "Non",
          confirmButtonText: "Oui, se déconnecter",
          icon: "question"
        })).isConfirmed
      ) {
        localStorage.removeItem("stratochange.user")
        this.$router.push("/login")
      }
    }
  },

  computed: {
    $user() {
      const user = localStorage.getItem("stratochange.user");

      if (user) {
        return JSON.parse(user);
      }

      return null;
    },

    $isLoggedIn() {
      return !!this.$user();
    }
  }
};
